import React, { PureComponent, Children, Fragment } from 'react';

interface IBackroundImageElementProps {
  classNames?: string[];
  tag?: any;
  imageName: string;
  extension?: string;
  onClick?: any;
}

interface IImageState {
  src: string;
}

export default class BackroundImageElement extends PureComponent<
  IBackroundImageElementProps,
  IImageState
> {
  private imageRef: React.MutableRefObject<HTMLElement>;
  constructor(props: IBackroundImageElementProps) {
    super(props);
    const ext = this.props.extension ? '.' + this.props.extension : '';
    this.state = {
      src: require(`../../../assets/${this.props.imageName}${ext}`)
    };
    this.imageRef = React.createRef();
  }

  componentDidMount() {
    const src = this.imageRef.current.getAttribute('data-image');
    if (src.indexOf('$staticlink$') === -1 && src.indexOf('http') !== -1) {
      this.setState({ src });
    }
  }

  render() {
    const { tag: Tag = 'div', classNames, children, onClick } = this.props;
    const { src } = this.state;
    const classes = classNames ? classNames.join(' ') : '';
    const style = {
      backgroundImage: `url(${src})`
    };

    return (
      <Tag
        ref={this.imageRef}
        className={classes}
        data-image={src}
        style={style}
        {...(onClick && { onClick })}
      >
        {children}
      </Tag>
    );
  }
}
